import { ClientPolicy } from '../Client'
import { PaymentMethod } from '../PaymentMethod'
import { PaymentType } from '../PaymentType'
import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
import { getCoreDetail, getPayOutDetail } from './common/payout'
import { pipe } from 'fp-ts/lib/function'
import * as O from 'fp-ts/lib/Option'

export interface VERSurrenderValuePaymentForAutoTerminatedPolicy {
  tag: TransactionType.SURRENDER_VALUE_PAYMENT_FOR_AUTO_TERMINATED_POLICY
  cashOutList?: api.PaymentData.CashOutList
  branchName: string
  policyNumber: string
  methods: PaymentMethod[]
  totalPayoutAmount: number
  source: string
}
export const SurrenderValuePaymentForAutoTerminatedPolicy = (
  taskDetail: api.SurrenderValuePaymentForAutoTerminatedPolicy & api.TaskDetailBase,
  clientPolicy: Array<ClientPolicy>,
  poName: string,
  policyNumber: string,
  branchName?: string
): VERSurrenderValuePaymentForAutoTerminatedPolicy => {
  const coreStatus = getCoreDetail(taskDetail.coreResponseDetail, taskDetail.payload.body.cashOutOptions || [])
  const cashOutList =
    taskDetail.payload && taskDetail.payload.body
      ? taskDetail.payload.body.cashOutOptions?.filter(
        (x) =>
          PaymentType.BANKTRANSFER === x.type ||
          PaymentType.PAID_AT_BANK === x.type ||
          PaymentType.CASH_AT_COUNTER === x.type
      )
      : []
  const cutomedTotalPayoutAmount = pipe(
    taskDetail.payload.body,
    O.fromNullable,
    O.fold(
      () => 0,
      (payloadData) => payloadData.attributesExt.TOTAL_PAYOUT_AMOUNT
    )
  )
  return {
    tag: TransactionType.SURRENDER_VALUE_PAYMENT_FOR_AUTO_TERMINATED_POLICY,
    cashOutList: cashOutList,
    branchName: branchName || '',
    policyNumber: policyNumber,
    totalPayoutAmount: cutomedTotalPayoutAmount,
    source: taskDetail.payload.source,
    methods: taskDetail.payload.body.cashOutOptions?.map((v, i) => ({
      method: v.type ?? '',
      detail: getPayOutDetail(
        {
          type: v.type as PaymentType,
          officeCode:
            (v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PVA_CASH_OUT_OPTION_INFO.officeCode) || '',

          bankAccount: {
            accountName:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountName) ||
              (v.type === PaymentType.PAID_AT_BANK &&
                (v.attributesExt?.PAYEE_INFO?.payeeName === '' ? poName : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
              (v.type === PaymentType.CASH_AT_COUNTER &&
                (v.attributesExt?.PAYEE_INFO?.payeeName === '' ? poName : v.attributesExt?.PAYEE_INFO?.payeeName)) ||
              ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.payeeName) ?? poName) ||
              '-',
            accountNo:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.accountNo) ||
              ((v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                taskDetail.clientNumber) ||
              ((v.type === PaymentType.CASH_AT_COUNTER && v.attributesExt?.PAYEE_INFO?.idNumber) ??
                taskDetail.clientNumber) ||
              ((v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.idNumber) ?? taskDetail.clientNumber) ||
              '-',
            bankName:
              (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.bankName) ||
              (v.type === PaymentType.PAID_AT_BANK && v.bankAccount?.bankName) ||
              '-',
            branchName:
              (v.type === PaymentType.BANKTRANSFER && branchName) ||
              (v.type === PaymentType.PAID_AT_BANK && branchName) ||
              undefined,
            bankCode: '-',
            branchCode: (v.type === PaymentType.BANKTRANSFER && v.bankAccount?.branchCode) || '-'
          },
          phoneNumber: (v.type === PaymentType.MOMO && v.attributesExt?.PAYEE_INFO?.phone) || '',
          issuedDate: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedDate) || '',
          issuedBy: (v.type === PaymentType.PAID_AT_BANK && v.attributesExt?.PAYEE_INFO?.issuedBy) || '',
          policy: {
            policyNo: v.policy?.policyNo || '-'
          }
        },
        clientPolicy
      ),
      amount: v.paymentOption.amount || 0,
      status: coreStatus[i].status,
      note: coreStatus[i].errorMes,
      action: '-',
      bankCode: v.type === PaymentType.BANKTRANSFER ? v.bankAccount?.bankName || '-' : undefined
    })) || []
  }
}